export default __webpack_public_path__ + "static/media/8_2.b1a7866b.jpg";